export class Compromiso{
    idCompromiso:string='';
    activo:string='';
    descripcion:string='';
    fechaCompleta:string='';
    annio:string='';
    mes:string='';
    dia:string='';
    minuto:string='';
    hora:string='';
    horaCompleta:string='';
    datoProducidoBanrep:string='';
    indicaCalendarioOECD:string='';
    categoriaNivel1:string='';
    categoria:string='';
    ordenPublicacion:string='';
    estilo:string='';
    periodicidad:string='';
    fechaDesde:string='';
    fechaHasta:string='';

    tituloFechaCorte:string='';
}